export const PATIENT_INTERVENTION_DEFAULT_SORT = {
  sortedColumn: 'targetDate',
  sortedColumnOrder: 'descend'
}

export const PATIENT_GOAL_TYPE_LIST = [
  {
    key: 0,
    value: 'predefined',
    title: 'Select from predefined goals'
  },
  {
    key: 1,
    value: 'new',
    title: 'Create custom goals'
  }
]

export const PATIENT_INTERVENTION_TYPE_LIST = [
  {
    key: 0,
    value: 'predefined',
    title: 'Select from predefined interventions'
  },
  {
    key: 1,
    value: 'custom',
    title: 'Create custom interventions'
  }
]

export const ADDITIONAL_GOAL_CATEGORY_LIST = [
  {
    title: 'Education',
    type: 2
  },
  {
    title: 'Clinical Pathway',
    type: 3
  }
]

export const PATIENT_GOAL_DEFAULT_SORT = {
  sortedColumn: 'categoryTitle',
  sortedColumnOrder: 'ascend'
}
